export default "__VITE_ASSET__7d2ae791__"